import { Flex, Text } from '@mantine/core';
import image from '../../../../../assets/placeholder.svg';
import { useTranslation } from 'react-i18next';

export const EmptyPlaceholder = ({ forOpen }: { forOpen: boolean }) => {
  const { t } = useTranslation('questionnaire');

  const message = forOpen
    ? t('Placeholder.NoOpenQuestionnaires')
    : t('Placeholder.NoClosedQuestionnaires');

  return (
    <Flex direction="column" align="center" justify="center" ta="center">
      {image && (
        <img
          src={image}
          alt="No questionnaires"
          width={110}
          style={{ borderRadius: '4px', padding: '20px 0px' }}
        />
      )}
      <Text>{message}</Text>
    </Flex>
  );
};
